var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8 11v2c0 .557-.447 1-1 1H5c-.557 0-1-.447-1-1v-2c0-.557.447-1 1-1h2c.557 0 1 .447 1 1m6 0v2c0 .557-.447 1-1 1h-2c-.557 0-1-.447-1-1v-2c0-.557.447-1 1-1h2c.557 0 1 .447 1 1m6 2v-2c0-.553-.443-1-1-1h-2c-.553 0-1 .443-1 1v2c0 .553.443 1 1 1h2c.553 0 1-.443 1-1",
  clipRule: "evenodd"
})));
export default SvgGemChannelMore;